<script setup lang="ts">
  import { computed } from 'vue';
  import PosUiButton from '@/components/pos-v2/ui/PosUiButton.vue';
  import { getStaffActions } from '@/domain/reservations/reservation-status';
  import type { IStaffActionId } from '@/domain/reservations/reservation-status';
  import type { IReservation } from '@/interfaces/IReservation';
  const props = withDefaults(
    defineProps<{
      reservation: IReservation;
      now: Date;
      timeZone: string;
      businessDayStartHour?: number;
      busy?: boolean;
      canManage: boolean;
      canOrders: boolean;
    }>(),
    { busy: false, businessDayStartHour: 4 }
  );
  const emit = defineEmits<{
    (event: 'action', action: IStaffActionId): void;
  }>();
  const actions = computed(() =>
    getStaffActions(
      props.reservation,
      props.now,
      props.timeZone,
      props.businessDayStartHour
    ).filter((action) =>
      action.requiresOrdersManage ? props.canOrders : props.canManage
    )
  );
</script>

<template>
  <div class="reservation-status-actions">
    <p v-if="reservation.status === 'pending_payment'" class="deposit-hint">
      {{ $t('reservations.detail.awaitingDeposit') }}
    </p>
    <div class="actions-grid">
      <PosUiButton
        v-for="action in actions"
        :key="action.id"
        :color="
          action.primary ? 'primary' : action.destructive ? 'error' : 'neutral'
        "
        :variant="
          action.primary ? 'solid' : action.destructive ? 'soft' : 'outline'
        "
        :disabled="busy"
        :class="{ primary: action.primary }"
        @click="emit('action', action.id)"
        >{{ $t(action.labelKey) }}</PosUiButton
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
  .reservation-status-actions {
    @apply tw-border-b tw-border-neutral-200 tw-px-5 tw-py-3;
    .deposit-hint {
      @apply tw-mb-2 tw-text-sm tw-text-amber-800;
    }
    .actions-grid {
      @apply tw-flex tw-flex-wrap tw-gap-2;
    }
    .primary {
      @apply tw-flex-grow;
    }
  }
</style>
